import axios from "axios";
import _ from "lodash";
import { useQuery } from "react-query";

import { PACTSAFE_URL } from "shared/config/constants/app.constants";
import api from "shared/lib/api";
import { PactSafeConfigParams } from "shared/lib/api/configApi";

export const useGetSSOConfig = () => {
  const { data: ssoConfig, isLoading: isSSOConfigLoading } = useQuery(
    ["getSSOConfig"],
    () => api.getSSOConfig(),
    {
      cacheTime: Infinity,
      staleTime: Infinity,
    }
  );

  return {
    ssoConfig,
    isSSOConfigLoading,
  };
};

export const useGetPactSafeConfig = (data?: PactSafeConfigParams) => {
  const { data: pactSafeConfig, isLoading: isPactSafeConfigLoading } = useQuery(
    ["getPactSafeConfig"],
    () => api.getPactSafeConfig(data),
    {
      retry: false,
      cacheTime: Infinity,
      staleTime: Infinity,
    }
  );

  return {
    pactSafeConfig,
    isPactSafeConfigLoading,
  };
};

/**
 * Standalone function to check if a user has already accepted a PactSafe agreement.
 * @param params Object with signerEmail, groupKey, and accessId
 * @returns Promise<boolean> true if accepted, false otherwise
 */
export async function checkPactSafeAgreement({
  signerEmail,
  groupKey,
  accessId,
}: {
  signerEmail: string;
  groupKey: string;
  accessId: string;
}): Promise<boolean> {
  const params = {
    sid: accessId,
    sig: signerEmail,
    gkey: groupKey,
  };
  // data here is an object of keys which will have boolean value
  const { data } = await axios.get(`${PACTSAFE_URL}/latest`, { params });
  return _.some(data, (item) => item === true);
}
